import { render, staticRenderFns } from "./MetricsValues.vue?vue&type=template&id=667a58f6"
import script from "./MetricsValues.vue?vue&type=script&lang=js"
export * from "./MetricsValues.vue?vue&type=script&lang=js"
import style0 from "./MetricsValues.vue?vue&type=style&index=0&id=667a58f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports